import axios from 'axios';
import { CohortMembersCountResponse } from './Summary';
import properties from '../../properties';

export const getUtilizationAdmissionCohortCount = async (
  eg_nid: string[],
  incurredStartDate: string,
  incurredEndDate: string,
  paidStartDate: string,
  paidEndDate: string,
  aggregationParameter: string,
  admissionFlag: string,
): Promise<CohortMembersCountResponse> => {
  const response = await axios.post(
    properties.aiqBaseUrl +
      properties.utilizationBaseUrl +
      properties.getUtilizationAdmissionMemberCount,
    {
      eg_nid,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      admissionFlag,
    },
  );
  return response.data.data;
};
